import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../mock';

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-24 bg-slate-50/60 scroll-mt-24">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center">
          <span className="chip">FAQ</span>
          <h2 className="mt-5 text-4xl md:text-5xl font-bold text-[#0a2540] tracking-tight leading-[1.05]">
            Questions? <span className="font-serif-display italic text-teal-600">We have answers.</span>
          </h2>
        </div>

        <div className="mt-12 space-y-3">
          {faqs.map((f, i) => (
            <div key={i} className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between px-6 py-5 text-left" aria-expanded={open===i}>
                <span className="text-[16px] font-semibold text-[#0a2540]">{f.q}</span>
                <span className={`h-8 w-8 rounded-full flex items-center justify-center border transition-colors ${open===i ? 'bg-teal-500 border-teal-500 text-white' : 'border-slate-300 text-slate-500'}`}>
                  {open === i ? <Minus size={16}/> : <Plus size={16}/>}
                </span>
              </button>
              <div className={`grid transition-all duration-300 ${open===i ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                <div className="overflow-hidden">
                  <p className="px-6 pb-5 text-slate-600 leading-relaxed">{f.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
